var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9998 18.8223L14.7815 13.6039C16.137 11.9461 16.8035 9.83069 16.643 7.69525C16.4826 5.5598 15.5075 3.56772 13.9195 2.13105C12.3314 0.69437 10.252 -0.076978 8.11119 -0.0234515C5.97039 0.030075 3.93207 0.904381 2.41783 2.41862C0.903588 3.93286 0.0292815 5.97119 -0.024245 8.11198C-0.0777715 10.2528 0.693577 12.3322 2.13025 13.9203C3.56693 15.5083 5.55901 16.4834 7.69445 16.6438C9.82989 16.8043 11.9453 16.1378 13.6032 14.7823L18.8215 20.0006L19.9998 18.8223ZM8.33315 15.0006C7.01461 15.0006 5.72568 14.6096 4.62935 13.8771C3.53302 13.1445 2.67854 12.1033 2.17395 10.8852C1.66937 9.66699 1.53735 8.32655 1.79458 7.03334C2.05182 5.74014 2.68676 4.55225 3.61911 3.6199C4.55146 2.68755 5.73934 2.05261 7.03255 1.79538C8.32576 1.53814 9.6662 1.67016 10.8844 2.17475C12.1025 2.67933 13.1437 3.53382 13.8763 4.63014C14.6088 5.72647 14.9998 7.0154 14.9998 8.33394C14.9978 10.1014 14.2948 11.796 13.045 13.0458C11.7952 14.2956 10.1007 14.9986 8.33315 15.0006Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/search_white.18cfc9fc6e61c3d4911b23e7adebffd8.svg";
export { ForwardRef as ReactComponent };